export default "__VITE_ASSET__C1nzjf9j__"